import { gql } from '@apollo/client';

export const GET_COMPANY_BILLING_DETAILS_QUERY = gql`
  query GetCompanyBillingInformationQuery {
    getCompanyBillingDetails {
      ID
      paymentMethod
      isDelinquent
      becameDelinquentAt
      processoutId
      plan
      subscription {
        billingPeriodStartsAt
        billingPeriodEndsAt
        nextInvoiceAt
        recurrence
        isAutoRenewal
        pricePerAdditionalUser
        totalIncludedUsers
        maxAdditionalUsers
        billingFrequencyAddUserNumber
        currency
      }
    }
  }
`;
